window.addEventListener("DOMContentLoaded", () => {
  const initialQuickAdd = document.querySelectorAll(
    '*[data-action="quickview-open"]'
  );
  const quickCloseButtons = document.querySelectorAll(
    '*[data-action="quickview-close"]'
  );

  initialQuickAdd.forEach((quickAdd) => {
    registerQuickAdd(quickAdd);
  });

  quickCloseButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      quickAddPopup.classList.remove("Open");
    });
  });

  function registerQuickAdd(quickAdd) {
    quickAdd.dataset.registered = true;
    const a = quickAdd.querySelector("a");
    a.addEventListener("click", (e) => {
      e.preventDefault();
      window.dispatchEvent(
        new CustomEvent("quickadd:open", {
          detail: { id: quickAdd.dataset.id },
        })
      );
    });
  }

  window.addEventListener("global:align", function () {
    const initialQuickAdd = document.querySelectorAll(
      '*[data-action="quickview-open"]:not([data-registered])'
    );

    initialQuickAdd.forEach((quickAdd) => {
      registerQuickAdd(quickAdd);
    });
  });
});

const quickAddPopup = document.querySelector("#Quick_Add");

const MAIN_PRODUCT_SECTION_ID = "main-product"; // template--24008860401981__main ---- template--23189255258429__main

window.addEventListener("quickadd:open", function (e) {
  const path = `${e.detail.id}?section=${MAIN_PRODUCT_SECTION_ID}`;
  console.log(path);

  // Fetch product details
  fetch(path)
    .then((response) => response.text())
    .then((html) => {
      // let html = json[MAIN_PRODUCT_SECTION_ID];
      // parse the html
      console.log(html);
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const productSection = doc.querySelector(".Product_Section");

      console.log(doc);
      console.log(productSection);

      // Update quick add popup
      quickAddPopup.innerHTML = "";
      quickAddPopup.appendChild(productSection);
      quickAddPopup.classList.add("Open");
      window.dispatchEvent(new CustomEvent("global:align"));
    });
});

window.addEventListener("quickview:close", function () {
  quickAddPopup.classList.remove("Open");
});
